import { render, staticRenderFns } from "./RequestQuoteApp.vue?vue&type=template&id=894e324c"
import script from "./RequestQuoteApp.vue?vue&type=script&lang=js"
export * from "./RequestQuoteApp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports